/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import componentLoader from 'Util/componentLoader';

import { PostNordPointComponent } from './PostNordPoint.component';

export const PostNordDispatcher = componentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    '../../store/PostNord/PostNord.dispatcher'
), 2);
/** @namespace Bodymod/PostNord/Component/PostNordPoint/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    points: state.PostNordReducer.points,
    selectedPoint: state.PostNordReducer.selectedPoint
});

/** @namespace Bodymod/PostNord/Component/PostNordPoint/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    setPostNordSelectedPoint: (id) => PostNordDispatcher.then(
        ({ default: dispatcher }) => dispatcher.setPostNordSelectedPoint(id, dispatch)
    ),
    setPostNordPoint: (point) => PostNordDispatcher.then(
        ({ default: dispatcher }) => dispatcher.setPostNordPoint(point, dispatch)
    )
});

/** @namespace Bodymod/PostNord/Component/PostNordPoint/Container */
export class PostNordPointContainer extends PureComponent {
    static propTypes = {
        point: PropTypes.object.isRequired,
        setPostNordSelectedPoint: PropTypes.func.isRequired,
        setPostNordPoint: PropTypes.func.isRequired,
        selectedPoint: PropTypes.string.isRequired,
        setSelectedPostNordPoint: PropTypes.func.isRequired
    };

    containerFunctions = {
        onClick: this.onClick.bind(this)
    };

    containerProps() {
        const { point, selectedPoint } = this.props;

        return {
            point,
            selectedPoint
        };
    }

    onClick() {
        const {
            point, point: { id }, setPostNordSelectedPoint, setPostNordPoint, setSelectedPostNordPoint
        } = this.props;

        setPostNordSelectedPoint(id);
        setPostNordPoint(point);
        setSelectedPostNordPoint(point);
    }

    render() {
        return (
            <PostNordPointComponent
              { ...this.containerProps() }
              { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PostNordPointContainer);
